var map = {
	"./delete.png": "9453",
	"./file_new.png": "861df",
	"./folder.png": "1753",
	"./form.png": "75c4",
	"./graphics.png": "a292",
	"./graphics2.png": "31b0",
	"./grid.png": "ad06",
	"./group.png": "6b81",
	"./home.png": "273e",
	"./message-regular.svg": "eb08",
	"./paper.png": "a6f9",
	"./refresh.png": "c22e",
	"./sales.png": "4d67",
	"./subir-archivo.png": "4871",
	"./users.png": "4692"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4a78";